export const getNumberInGermanCurrency = (number: number) => {
  const options: Intl.NumberFormatOptions = {
    style: "currency",
    currency: "EUR",
  };

  return number.toLocaleString("de-DE", options);
};
